import { userService } from './UserService';
import { UserRole } from '../types/enums/UserRole';
import { UserDetail } from '../types/api/users/UserDetail';
import { Claims } from '../types/permissions/Claims';

class PermissionService {

    public hasPermissions(accountPermissions: readonly Claims[], permissionsToCheck: readonly Claims[]) {
        const permissionFound = permissionsToCheck.some((p) => {
            return accountPermissions.indexOf(p) >= 0;
        });

        return permissionFound;
    }
    
    public async getCurrentUser() {
        const currentUser = await userService.currentUser();
        return currentUser;
    }

    public async currentUserHasOnlyThisRole(role: UserRole) {
        const currentUser = await this.getCurrentUser();
        const userHasRole = currentUser === null ? false : this.userHasOnlyThisRole(currentUser, role);
        return userHasRole;
    }

    public userHasOnlyThisRole(user: UserDetail, role: UserRole) {
        const onlyHasRoleResult = user.roleId === role;
        return onlyHasRoleResult;
    }

    public async getCurrentPerson() {
        const currentPerson = await userService.currentPerson();
        return currentPerson;
    }

}

export const permissionsService = new PermissionService();